import OperateColumn from "./components/account/OperateColumn.vue";
import GroupOperateColumn from "./components/group/GroupOperateColumn.vue";
import RoleOperateColumn from "./components/role/RoleOperateColumn.vue";

import i18n from "@/i18n";

import { businessLangs } from "@/components/langSelect/languages.js";

export const groupOptions = () => {
    return [
        {
            label: i18n.t("zhiji.personnel.defaultGroup"),
            value: "all"
        }
    ];
};

// 账号管理表格配置
export const accountTableConfig = () => {
    return {
        columns: [
            {
                colId: "userName",
                header: i18n.t("zhiji.personnel.accountManage.tabelCloumn.name"),
                type: "Text",
                width: "10%"
            },
            {
                colId: "account",
                header: i18n.t("zhiji.personnel.accountManage.tabelCloumn.account"),
                type: "Text",
                width: "15%"
            },
            {
                colId: "userRole",
                header: i18n.t("zhiji.personnel.accountManage.tabelCloumn.role"),
                type: "Text",
                width: "10%"
            },
            {
                colId: "userGroup",
                header: i18n.t("zhiji.personnel.accountManage.tabelCloumn.group"),
                type: "Text",
                width: "10%"
            },
            {
                colId: "chatNum",
                header: i18n.t("zhiji.personnel.accountManage.tabelCloumn.chatMax"),
                type: "Text",
                width: "15%"
            },
            {
                colId: "maxWork",
                header: i18n.t("zhiji.personnel.accountManage.tabelCloumn.maxWork"),
                type: "Text",
                width: "12%"
            },
            {
                colId: "status",
                header: i18n.t("zhiji.personnel.statusLabel"),
                type: "Text",
                width: "8%"
            },
            {
                colId: "operate",
                header: i18n.t("zhiji.common.operate"),
                type: "Custom",
                width: "20%",
                component: OperateColumn
            }
        ],
        isHideFooter: true,
        pageLength: 10
    };
};

export const characterOptions = () => {
    return [
        {
            label: i18n.t("zhiji.personnel.adminLabel"),
            value: "admin"
        }
    ];
};

// 账号管理编辑：每日单数领取上限单选
export const accountRadios = () => [
    {
        label: i18n.t("zhiji.personnel.addBtnLabel"),
        value: "new",
        checked: true
    },
    {
        label: i18n.t("zhiji.personnel.link"),
        value: "related",
        checked: false
    }
];

// 账号管理编辑：每日单数领取上限单选
export const receiveChatRadios = () => [
    {
        label: i18n.t("zhiji.personnel.defaultLable"),
        value: "default",
        checked: true
    },
    {
        label: i18n.t("zhiji.personnel.customLabel"),
        value: "custom",
        checked: false
    }
];

// 账号管理编辑：每日单数领取上限单选
export const maxChatRadios = () => [
    {
        label: i18n.t("zhiji.personnel.defaultLable"),
        value: "default",
        checked: true
    },
    {
        label: i18n.t("zhiji.personnel.customLabel"),
        value: "custom",
        checked: false
    }
];

// 分组管理表格配置
export const groupTableConfig = () => {
    return {
        columns: [
            {
                colId: "groupName",
                header: i18n.t("zhiji.personnel.groupManage.tabelCloumn.groupName"),
                type: "Text",
                width: "12%"
            },
            {
                colId: "member",
                header: i18n.t("zhiji.personnel.groupManage.tabelCloumn.member"),
                type: "Text",
                width: "33%"
            },
            {
                colId: "language",
                header: i18n.t("zhiji.common.language"),
                type: "Text",
                width: "8%"
            },
            {
                colId: "classify",
                header: i18n.t("zhiji.personnel.groupManage.tabelCloumn.groupClassify"),
                type: "Text",
                width: "10%"
            },
            {
                colId: "doMax",
                header: i18n.t("zhiji.personnel.groupManage.tabelCloumn.doMax"),
                type: "Text",
                width: "8%"
            },
            {
                colId: "tagName",
                header: "关联标签",
                type: "Text",
                width: "18%"
            },
            {
                colId: "status",
                header: i18n.t("zhiji.personnel.statusLabel"),
                type: "Text",
                width: "8%"
            },
            {
                colId: "operate",
                header: i18n.t("zhiji.common.operate"),
                type: "Custom",
                width: "20%",
                component: GroupOperateColumn
            }
        ],
        isHideFooter: true,
        pageLength: 10
    };
};

// 语言选择
export const languageOptions = () => {
    return [
        ...businessLangs().map(lang => {
            return {
                label: i18n.t(lang.i18nKey),
                value: lang.lang
            };
        })
    ];
};

// 角色管理表格配置
export const roleTableConfig = () => {
    return {
        columns: [
            {
                colId: "roleName",
                header: i18n.t("zhiji.personnel.roleManage.tabelCloumn.roleName"),
                type: "Text",
                width: "20%"
            },
            {
                colId: "perModule",
                header: i18n.t("zhiji.personnel.roleManage.tabelCloumn.roleModule"),
                type: "Text",
                width: "30%"
            },
            {
                colId: "remarks",
                header: i18n.t("zhiji.personnel.roleManage.tabelCloumn.remark"),
                type: "Text",
                width: "20%"
            },
            {
                colId: "status",
                header: i18n.t("zhiji.personnel.statusLabel"),
                type: "Text",
                width: "10%"
            },
            {
                colId: "operate",
                header: i18n.t("zhiji.common.operate"),
                type: "Custom",
                width: "20%",
                component: RoleOperateColumn
            }
        ],
        isHideFooter: true,
        pageLength: 10
    };
};

// 选择组别
export const groupTypes = {
    allGroupChecked: 3, // 全选
    chatChecked: 2, //会话组
    workChecked: 1, // 工单组
    noChecked: 0 // 无组别
};

// 账号新增数据校验
export const inputRules = () => {
    return {
        userName: {
            rules: [
                { rule: "checkNoNull", msg: i18n.t("zhiji.personnel.accountManage.accountEditModal.checkNameTips") },
                { rule: "checkNickName", msg: i18n.t("zhiji.personnel.accountManage.accountEditModal.nameErrorTip") }
            ]
        },
        email: {
            rules: [
                { rule: "checkNoNull", msg: i18n.t("zhiji.personnel.accountManage.accountEditModal.checkEmailTip") },
                { rule: "checkEmail", msg: i18n.t("zhiji.personnel.accountManage.accountEditModal.emailErrorTip") }
            ]
        }
    };
};
